<template>
  <div class="modal">
    <TitleFrame :is-modal=true text="施設詳細">
      <template slot="contents">
        <div class="content-area">
          <div class="fix-area">
            <div class="name-area">
              <div class="title-name">
                <div>{{selectedSpot.name}}</div>
              </div>
              <div
                class="ansin-icon"
                :class="{'ansin-clicked':isRelieved}"
                @click="onClickAnsin"
              >
                <img v-if="isRelieved" class="ansin-img" src="@/assets/heart-filled.png">
                <img v-if="!isRelieved" class="ansin-img" src="@/assets/heart.png">
                {{selectedSpotRelieved}}
              </div>
            </div>
            <TextLink class="gotohere" text="ここへ行く" @click-text="onClickGo" />
          </div>
          <div class="modal-content-area">
            <div class="image-area">
              <div class="img-area" v-for="(item, index) in selectedSpot.photos" :key="index">
                <img class="img" :src=loadGoogleImage(item)>
              </div>
            </div>
            <TitleAndText v-if="selectedSpot.formatted_address" title="住所" :text=selectedSpot.formatted_address />
            <TitleAndText v-else-if="selectedSpot.address" title="住所" :text=selectedSpot.address />

            <div v-if="selectedSpot.opening_hours">
              <div class="title-text" @click="changeWeekDayOpenStatus">営業時間
                <span class="triangle" v-if="!isWeekdayOpen">▼</span>
                <span class="triangle" v-if="isWeekdayOpen">▲</span>
              </div>
              <span v-for="(item, index) in selectedSpot.opening_hours.weekday_text" :key="index">
                <div v-if="contain(item,selectedDay) || isWeekdayOpen" :class="{'today':contain(item,selectedDay)&&isWeekdayOpen}">
                  {{showWeekdayList[index]}}:{{getOpeningHoursText(item)}}
                </div>
              </span>
            </div>
            <div v-else-if="selectedSpotParsedBusinessHours">
              <div class="title-text" @click="changeWeekDayOpenStatus">営業時間
                <span class="triangle" v-if="!isWeekdayOpen">▼</span>
                <span class="triangle" v-if="isWeekdayOpen">▲</span>
              </div>
              <span v-for="(item, index) in selectedSpotParsedBusinessHours" :key="index">
                <div v-if="contain(item,selectedDay) || isWeekdayOpen" :class="{'today':contain(item,selectedDay)&&isWeekdayOpen}">
                  {{item}}
                </div>
              </span>
            </div>
            <TitleAndText v-else-if="selectedSpot.business_hours" title="営業時間" :text=selectedSpot.business_hours />
            <TitleAndText v-if="selectedSpot.formatted_phone_number" title="TEL" :text=selectedSpot.formatted_phone_number />
            <TitleAndText v-else-if="selectedSpot.tel" title="TEL" :text=selectedSpot.tel />

            <TitleAndText v-if="selectedSpot.rating" title="評価" :text="originalToString(selectedSpot.rating)" />
            <TitleAndText v-else-if="selectedSpot.reputation" title="評価" :text="originalToString(selectedSpot.reputation)" />

            <TitleAndText v-if="selectedSpotType" title="カテゴリ" :text=selectedSpotType />

            <div v-if="selectedSpotCongestion">
              <div class="title-text">混雑度</div>
              {{mappingCongestionStatus(selectedSpotCongestion.congestion)}}
              (更新日時：
                {{convertTime(selectedSpotCongestion.created_at).date}}
                {{convertTime(selectedSpotCongestion.created_at).time}}
              )<br>
              <div v-if="selectedSpotCongestion.comment!==''">コメント：{{selectedSpotCongestion.comment}}</div>
              ※混雑状況が変化した際には情報を更新します。タイムラグにより実際の状況と異なる場合があります。
            </div>

            <div v-if="!(selectedSpotMeasure==='不明') && !(selectedSpotMeasure.length===0)">
              <div class="title-text">コロナ対策</div>
              <span v-if="selectedSpotMeasure==='不明'">不明</span>
              <span v-else-if="selectedSpotMeasure.length===0">不明</span>
              <span>
                <div>
                  <span v-for="(item, index) in showMeasureList" :key="index">
                    <span>
                      {{item}}
                      <span v-if="index !== (showMeasureList.length-1)">、</span>
                    </span>
                  </span>
                </div>
                <div>
                  <div class="measure-area">
                    <div class="mes-area" v-for="(item, index) in selectedSpotMeasure" :key="index">
                      <img v-if=item.measure.image_url class="mes" :src=item.measure.image_url>
                    </div>
                  </div>
                </div>
              </span>
            </div>

            <div v-if="selectedSpot.url">
              <div class="title-text">GoogleMap連携</div>
              <TextLink text="GoogleMapで見る" @click-text="onClickUrl(selectedSpot.url)" />
            </div>

            <div v-if="selectedSpot.website">
              <div class="title-text">ホームページ</div>
              <TextLink text="ホームページをみる" @click-text="onClickUrl(selectedSpot.website)" />
            </div>
            <div v-else-if="selectedSpot.home_page_url">
              <div class="title-text">ホームページ</div>
              <TextLink text="ホームページをみる" @click-text="onClickUrl(selectedSpot.home_page_url)" />
            </div>

            <div v-if="selectedSpot.reviews">
              <div class="title-text">レビュー</div>
              <div v-if="selectedSpot.reviews" class="review-area">
                <div class="rev-area">
                  <div class="review" v-for="(item, index) in selectedSpot.reviews" :key="index">
                    {{item.author_name}}<br><br>
                    {{item.text}}
                  </div>
                </div>
              </div>
            </div>
            <TextLink class="gotohere" text="ここへ行く" @click-text="onClickGo" />

            <div>
              <img class="g-logo" src="@/assets/powered_by_google_on_white_hdpi.png">
            </div>
          </div>
        </div>
      </template>
    </TitleFrame>
  </div>
</template>

<script>
import { mapState, mapMutations } from 'vuex'
import TitleAndText from '@/components/Atoms/TitleAndText'
import TitleFrame from '@/components/Templates/TitleFrame'
import TextLink from '@/components/Atoms/TextLink'
import Firebase from './../../firebase'

export default {
  name: 'detail-modal',
  components: {
    TitleAndText,
    TitleFrame,
    TextLink
  },
  computed: {
    ...mapState([
      'selectedSpot',
      'selectedSpotType',
      'originalApiData',
      'selectedSpotRelieved',
      'relievedLog',
      'selectedSpotDocId'
    ]),
    selectedSpotParsedBusinessHours () {
      let results = null
      if (this.selectedSpot && this.selectedSpot.business_hours != null) {
        const quoteSplit = this.selectedSpot.business_hours.split(',')
        if (quoteSplit.length > 1) {
          for (let i = 0; i < quoteSplit.length; i++) {
            const quateItem = quoteSplit[i]
            if (quateItem.match('[月火水木金土日]曜日')) {
              if (!results) {
                results = []
              }
              results.push(quateItem)
            }
          }
        }
      }
      return results
    },
    selectedSpotCongestion () {
      if (this.selectedSpot) {
        var reportList
        let oriData = this.originalApiData.filter(x => x.service_place_id === this.selectedSpot.place_id)[0]
        if (oriData) reportList = oriData.reports
        if (this.selectedSpot.reports) reportList = this.selectedSpot.reports
        if (reportList) {
          reportList.sort(function (a, b) {
            return (a.created_at < b.created_at ? 1 : -1)
          })
          return reportList[0]
        } else return reportList
      }
      return '不明'
    },
    selectedSpotMeasure () {
      if (this.selectedSpot) {
        let oriData = this.originalApiData.filter(x => x.service_place_id === this.selectedSpot.place_id)[0]
        if (oriData) return oriData.measure_spots
        if (this.selectedSpot.measure_spots) return this.selectedSpot.measure_spots
      }
      return '不明'
    },
    showMeasureList () {
      if (this.selectedSpotMeasure !== '不明') {
        var showList = []
        for (let item of this.selectedSpotMeasure) {
          if (!item.measure.image_url) {
            if (item.measure.name === 'その他') {
              showList.push(item.comment)
            } else {
              showList.push(item.measure.name)
            }
          }
        }
      }
      return showList
    },
    isRelieved () {
      return this.relievedLog.filter(x => x === this.selectedSpotDocId).length
    }
  },
  data () {
    return {
      selectedDay: '日',
      showWeekdayList: [ '月曜日', '火曜日', '水曜日', '木曜日', '金曜日', '土曜日', '日曜日' ],
      weekdayList: [ '日曜日', '月曜日', '火曜日', '水曜日', '木曜日', '金曜日', '土曜日' ],
      isWeekdayOpen: false,
      report: undefined
    }
  },
  methods: {
    ...mapMutations([
      'closeModalAll',
      'setDropDestionaton'
    ]),
    mappingCongestionStatus (num) {
      if (num === 0) return '不明'
      else if (num === 1) return '定員の半分以下'
      else if (num === 2) return '待ち時間無し'
      else if (num === 3) return '待ち時間10分以上'
      else if (num === 4) return '待ち時間30分以上'
      else return '不明'
    },
    convertTime (datetime) {
      let dateRegexp = '[0-9]{4}-[0-9]{2}-[0-9]{2}'
      let timeRegexp = '[0-9]{2}:[0-9]{2}:[0-9]{2}'

      let extractedDate = datetime.match(dateRegexp)[0]
      let extractedTime = datetime.match(timeRegexp)[0]

      return {
        date: extractedDate,
        time: extractedTime
      }
    },
    changeWeekDayOpenStatus () {
      this.isWeekdayOpen = !this.isWeekdayOpen
    },
    loadGoogleImage (e) {
      return e.getUrl()
    },
    originalToString (value) {
      return value.toString()
    },
    contain (target, findText) {
      return target.indexOf(findText) !== -1
    },
    getOpeningHoursText (value) {
      const reg = new RegExp(' .*', 'g')
      let parsedString = value.match(reg)
      return parsedString[0]
    },
    onClickUrl (e) {
      window.open(e, '_blank')
    },
    onClickAnsin () {
      if (!this.isRelieved) {
        navigator.geolocation.getCurrentPosition(function (position) {
          Firebase.putLog({
            ActionType: 'PushReliefButton',
            CurrentLatLon: {
              current_lat: position.coords.latitude,
              current_lon: position.coords.longitude
            }
          })
        },
        function (err) {
          var msgs = [
            err.message,
            '位置情報の取得を許可されていません。',
            '位置情報の取得に失敗しました。',
            '位置情報を取得中にタイムアウトしました。'
          ]
          window.alert(msgs[err.code])
        },
        { maximumAge: 0 })
        Firebase.putSpot()
      }
    },
    onClickGo () {
      let latlng
      if (this.selectedSpot.geometry) latlng = this.selectedSpot.geometry.location
      else latlng = new window.google.maps.LatLng(this.selectedSpot.lat, this.selectedSpot.lon)

      this.setDropDestionaton({latlng: latlng, name: this.selectedSpot.name})
      this.closeModalAll()

      Firebase.putLog({ ActionType: 'ChooseSpotInDetail' })
      this.$router.push({name: 'RouteResult'})
    }
  },
  mounted () {
    var date = new Date()
    var dayOfWeek = date.getDay()
    var dayOfWeekStr = this.weekdayList[dayOfWeek]
    this.selectedDay = dayOfWeekStr
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="scss" scoped>
@import './../../unified.scss';
.content-area{
  position: fixed;
  height:calc(100% - 4rem);
  overflow: scroll;
}
.modal{
  background-color: white;
  z-index:1;
  position:fixed;
  width:100%;
  height:100%;
}
.name-area{
  width:100%;
  display:flex;
}
.title-name {
  width:calc(100% - 4rem);
  font-weight: bold;
  font-size: 1.2rem;
  display:flex;
  align-items: center;
  vertical-align: middle;
}
.ansin-icon {
  margin: 0rem 0rem 0rem 1rem;
  padding:0.2rem;
  border-radius: 0.5rem;
  width:2rem;
  height:3rem;
  text-align:center;
  background-color: hotpink;
}
.ansin-clicked{
  background-color: pink;
}
.ansin-img{
  width:1.5rem;
}
.title-text {
  margin:0.5rem 0rem 0rem 0rem;
  font-weight: bold;
}
.hide{
  visibility: hidden;
}
.review-area{
  width:100%;
  display:flex;
  overflow: scroll;
}
.rev-area{
  align-items: center;
  display: flex;
}
.review{
  width: 10rem;
  height: 10rem;
  margin: 0.2rem 0.5rem;
}
.measure-area{
  width:100%;
  display:flex;
  flex-wrap: wrap;
}
.mes-area{
  align-items: center;
  display: flex;
}
.mes{
  max-width:7rem;
  max-height:6rem;
  margin:0.2rem 0.5rem;
}
.select-box{
  display:inline;
}
.gotohere{
  font-weight: bold;
  font-size:1.2rem;
  margin-top:1rem;
}
.fix-area{
  width:95%;
}
.modal-content-area{
  top:11rem;
  width:95%;
  height: calc(100% - 13rem);
}
.image-area{
  width:100%;
  display:flex;
  overflow: scroll;
}
.img-area{
  align-items: center;
  display: flex;
}
.img{
  max-width:7rem;
  max-height:6rem;
  margin:0.2rem 0.5rem;
}
.today{
  font-weight: bold;
}
.triangle{
  color: blue;
}
.g-logo{
  width: 50%
}
</style>



// WEBPACK FOOTER //
// src/components/Pages/ModalAll.vue